import { render, staticRenderFns } from "./TaskCardSteps.vue?vue&type=template&id=90f1e78a&"
import script from "./TaskCardSteps.vue?vue&type=script&lang=js&"
export * from "./TaskCardSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports